<template>
    <span
        v-if="to === null"
        :class="classes"
    >
        {{ $te(text) ? $t(text) : text }}
        <CoreIcon
            v-if="iconName"
            :name="iconName"
            size="16"
        />
    </span>

    <router-link
        v-else
        :class="classes"
        :to="to"
    >
        {{ $te(text) ? $t(text) : text }}
        <CoreIcon
            v-if="iconName"
            :name="iconName"
            size="16"
        />
    </router-link>
</template>

<script>
import CoreIcon from './CoreIcon.vue'

export default {
    name: 'CoreLinkPrimary',

    components: { CoreIcon },

    props: {
        to: {
            type: Object,
            default: null,
        },

        text: {
            type: String,
            default: '',
        },

        iconName: {
            type: String,
            default: null,
        },

        condensed: {
            type: Boolean,
            default: false,
        },

        linkColorBlue: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        classes() {
            return {
                'core-link-primary': true,
                'core-link-primary--condensed': this.condensed,
                'text-link': this.linkColorBlue,
            }
        },
    },
}
</script>

<style scoped>
.core-link-primary {
    display: flex;
    width: fit-content;
    gap: 8px;
    align-items: center;
    cursor: pointer;

    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }

    &:focus {
        text-decoration: underline;
    }

    &:active {
        color: var(--color-secondary);
        text-decoration: underline;
    }

    &:visited {
        color: var(--color-secondary);
    }
}

.core-link-primary > span.material-design-icon {
    display: flex;
    align-items: center;
}

.core-link-primary:hover,
.core-link-primary:active,
.core-link-primary:focus {
    text-decoration: underline;
}
</style>
